module.exports = __webpack_public_path__ + "static/media/pebbble2.679f5cef.gif";